import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CarouselSection />
        <TopicsSection />
        <ContactSection />
        <IndexSection />
        <RankingSection />
        <FeaturesSection />
        <CommentsSection />
        <AppSection />
        <MediaSection />
        <CardsSection />
        <AboutSection />
        <FaqSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}